var _dec, _class, _NoInputOverlay;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyle, jsx } from '@instructure/emotion';
import { View } from '@instructure/ui-view';
import { Heading } from '@instructure/ui-heading';
import { Link } from '@instructure/ui-link';
import { translate } from '../../../constants/translated/translations';
import generateStyle from './styles';

/**
---
private: true
---
**/
let NoInputOverlay = (_dec = withStyle(generateStyle), _dec(_class = (_NoInputOverlay = class NoInputOverlay extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props.makeStyles();
  }
  componentDidUpdate() {
    this.props.makeStyles();
  }
  getNoPermissionMessage() {
    const systemPermissionsLink = this.props.systemPermissionsLink;
    return jsx(View, {
      as: "div"
    }, jsx(Heading, {
      level: "h3",
      as: "div"
    }, translate('NO_SYSTEM_PERMISSION_OVERLAY_HEADING')), jsx(View, {
      as: "div",
      margin: "small 0"
    }, translate('NO_SYSTEM_PERMISSION_OVERLAY_TEXT')), systemPermissionsLink ? jsx(Link, {
      href: systemPermissionsLink,
      target: "_blank"
    }, translate('NO_SYSTEM_PERMISSION_OVERLAY_LINK')) : null);
  }
  getDefaultMessage() {
    const styles = this.props.styles;
    return jsx(View, {
      css: styles.biggerText
    }, translate('NO_INPUT_STREAM_AVAILABLE'));
  }
  render() {
    const _this$props = this.props,
      styles = _this$props.styles,
      noSystemPermission = _this$props.noSystemPermission;
    return jsx(View, {
      as: "div",
      css: styles.overlay
    }, jsx(View, {
      css: styles.contents
    }, noSystemPermission ? this.getNoPermissionMessage() : this.getDefaultMessage()));
  }
}, _NoInputOverlay.propTypes = {
  // eslint-disable-next-line react/require-default-props
  makeStyles: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  styles: PropTypes.object,
  noSystemPermission: PropTypes.bool.isRequired,
  systemPermissionsLink: PropTypes.string
}, _NoInputOverlay.defaultProps = {
  systemPermissionsLink: ''
}, _NoInputOverlay)) || _class);
export default NoInputOverlay;